import { Navigate, Route, Routes } from 'react-router-dom';

import { CustomAttributesTable } from './components/table/customAttributesTable';
import { SettingsCustomAttributesView } from './settingsCustomAttributes.view';

export const SettingsCustomAttributesRoutes = (): JSX.Element => {
  return (
    <Routes>
      <Route path="*" element={<SettingsCustomAttributesView />}>
        <Route
          path="conversation"
          element={<CustomAttributesTable entityId="conversation" />}
        />

        <Route
          path="contact"
          element={<CustomAttributesTable entityId="contact" />}
        />

        <Route
          path="*"
          element={<Navigate to="/settings/custom-attributes/conversation" />}
        />
      </Route>
    </Routes>
  );
};
